export const blackbaudUsersInitialState = {
	entities: {},
};

export const blackbaudUserInitialState = {
	_id: undefined,
	name: '',
	timezone_locale: '',
	renxt_tenantid: '',
	year_start_from: '',
};



// WEBPACK FOOTER //
// ./src/redux/blackbaudUsers/blackbaudUser.initialState.js